import { Component } from '@angular/core';
import { Message } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { link, breadcrumb, stat } from '../../layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { CategoryStateService } from 'src/app/services/category-state.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
@Component({
  selector: 'app-view-course',
  templateUrl: './view-course.component.html',
  styleUrls: ['./view-course.component.scss']
})
export class ViewCourseComponent {
  skeleton = true;
  showingSelectUser: boolean = false;
  currentCourse: any;

  //reject reason variable
  viewDetails: boolean = false
  completeCourseObject: any
  selected: any
  translator:TranslatorPipe = new TranslatorPipe()
  header =this.translate('Courses');
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [
    { name:this.translate('Courses'), link: '/course' },
  ];

  stats: stat[] = [];
  messages: Message[] = [];
  data: any[] = [];
  courseData: any[] = [];
  // trainingTypes: any[] = [];
  currentDate: Date = new Date();
  createTrainingModal = false;


  // status: string = 'PENDING';
  allData!: any[];
  filtered: any = [];

  statusOptions: any[] = [
    { name: this.translate('PENDING'), value: 'PENDING' },
    { name: this.translate('TRAINING_CREATED'), value: 'TRAINING_CREATED' },
    { name: this.translate('APPROVED'), value: 'APPROVED' },
    { name: this.translate('REJECTED'), value: 'REJECTED' },
    { name: this.translate('REVISION'), value: 'REVISION' },
  ];


  // file urls 
  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;

  type!: '';
  // sessions: any;
  surveys: any;
  assessments: any;
  courseMaterials!: [{ title: string, url: string }];

  createSession: boolean = false;
  assessment: boolean = false;
  survey: boolean = false;
  createProgramForm: FormBuilder | any;
  updateForm: FormBuilder | any

  trainers = [
    { name: 'Mateen', code: 'AU' },
    { name: 'Zaid', code: 'BR' },
    { name: 'Rao', code: 'CN' },
    { name: 'Junaid', code: 'EG' },
    { name: 'Fatima', code: 'FR' },
    { name: 'Mahir', code: 'DE' },
    { name: 'Ali', code: 'IN' },
    { name: 'Sufiyan', code: 'JP' },
    { name: 'Osama', code: 'ES' },
    { name: 'Rehman', code: 'US' }
  ];

  city: Array<Location | any> = [];
  openProgramModal: boolean = false;
  sectionTypeIdHolder: any

  message: any = undefined
  assessmentsList: any;
  selectedItem!: string;
  editForm = false;


  value!: string;

  filter: any[] = [
    { name: this.translate('completed'), value: 'COMPLETE' },
    { name: this.translate('current'), value: 'ONGOING' },
    { name: this.translate('pending'), value: 'PENDING' }
  ];
  ongoing!: boolean;
  complete!: boolean;
  pending!: boolean;

  constructor(
    private dataService: DataService, 
    private formBuilder: FormBuilder,
    private permissionService:PermissionHandlerService
  ) { }

  ngOnInit() {
    this.updateForm = new FormGroup({
      title: new FormControl()
    });
    this.getTrainingRequests();
  }

  hasPermission(unit:string,flag:string) {
    return this.permissionService.hasPermission(unit,flag);
  }
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  addAttendees(event: any) {
    if (event.emit) {
      let course = { _id: this.currentCourse._id, attendees: [] }
      course.attendees = event.users.map((u: any) => u._id);
      this.currentCourse.attendees = course.attendees;
      this.currentCourse = course;
      this.saveAttendees();
      this.currentCourse = null;
    }
    this.showingSelectUser = false;
  }

  openAttendeesModal(course: any) {
    this.currentCourse = course;
    this.showingSelectUser = true;
  }


  //get all cities
  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location.name,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async saveAttendees() {
    try {
      let response: any = await this.dataService.postData('course/', this.currentCourse, 'PUT', false);
      if (!response.error) {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
      }
    } catch (e) {
      console.log(e);
    }
  }

  //get all training requests
  getTrainingRequests = async () => {
    try {
      this.courseData = [];
      this.data = [];
      let res = await this.dataService.getData('course/');
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.courseData = res.data;
      this.allData = JSON.parse(JSON.stringify(res.data));
      this.courseData.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          topic: { n: item.topic, i: item.icon },
          type: { n: item?.type?.arabic },
          status: item.status,
          description: { n: item?.description },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateTypeCounts();
      this.skeleton = false;
      console.log('data ou catagory => ', this.courseData, this.data);
    } catch (error) {
      console.log(error);
    }
  };




  //updates the counts
  private updateTypeCounts(): void {
    let activeCount = this.courseData.filter(
      (e) => e.active === true
    ).length;
    let inactiveCount = this.courseData.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }

  courseDetail(course: any, view: boolean) {
    this.completeCourseObject = course;
    this.viewDetails = !view;
  }

  //creating validation object for training
  constructForObject(type: string) {

    if (type == 'SESSION') {
      this.createProgramForm = this.formBuilder.group({
        title: [null, [Validators.required, Validators.minLength(3)]],
        date: [Validators.required],
        start_time: [Validators.required],
        end_time: [Validators.required],
        trainer: [null, [Validators.required, Validators.minLength(3)]],
        is_online: [null, []],
        is_video: [null, []],
        video_url: [null, []],
        zoom_url: [null, []],
        houseNumber: [null, []],
        street: [null, []],
        city: [null, []],
      });
    }
    //SURVEY
    else {
      this.createProgramForm = this.formBuilder.group({
        title: [null, [Validators.required, Validators.minLength(3)]],
        date: [Validators.required],
        start_time: [Validators.required],
        end_time: [Validators.required],
      });
    }

  }

  // handle Session Submission
  async onSubmitProgram(type: string) {
    try {
      let typeForm;
      if (type == 'SESSION') {
        typeForm = this.createProgramForm.value;

      }
      //survey or Assessment
      else {
        typeForm = this.sectionTypeIdHolder

      }
      let { title, date, start_time, end_time } = this.createProgramForm.value
      let typeData: any = {
        title: title,
        type: type,
        typeId: { ...typeForm },
        date: date.toUTCString(),
        start_time: start_time,
        end_time: end_time
      }
      this.completeCourseObject.session.push(typeData)

      let response: any = await this.dataService.postData('course/', this.completeCourseObject);
      if (response.error == true) {
        this.message = response.msg;
      }
      else {
        // reload

        this.message = response.msg;
        this.resetSession();
        window.location.reload();

      }
    } catch (error) {
      console.log(error)

    }

    this.openProgramModal = false;
    this.createSession = false;
    this.assessment = false;
    this.survey = false;
  }

  resetSession() {
    this.sectionTypeIdHolder = null
    this.createProgramForm.reset();
  }

  addVideo(data: any) {
    this.createProgramForm.patchValue({
      video_url: data
    });
  }


  async filterByStatus(status: string) {
    this.courseData = JSON.parse(JSON.stringify(this.allData));
    this.ongoing = false;
    this.complete = false;
    this.pending = false;
    // let  status =  obj.value.join(',');
    this.filtered = [];
    if (status == 'ONGOING') {
      this.courseData.forEach(item => {
        if (new Date(item.start_date) <= this.currentDate && new Date(item.end_date) >= this.currentDate) {
          this.filtered.push(item);
          this.courseData.splice(this.courseData.indexOf(item._id), 1);
        }
      });
      this.courseData = this.filtered;
      this.ongoing = true;
      this.complete = false;
      this.pending = false;
    }
    else if (status == 'COMPLETE') {
      this.courseData.forEach(item => {
        if (new Date(item.end_date) < this.currentDate) {
          this.filtered.push(item);
          this.courseData.splice(this.courseData.indexOf(item._id), 1);
        }
      });
      this.courseData = this.filtered;
      this.ongoing = false;
      this.complete = true;
      this.pending = false;
    }
    else {
      this.courseData.forEach(item => {
        if (new Date(item.start_date) > this.currentDate) {
          this.filtered.push(item);
          this.courseData.splice(this.courseData.indexOf(item._id), 1);
        }
      });
      this.courseData = this.filtered;
      this.ongoing = false;
      this.complete = false;
      this.pending = true;
    }


    //  else this.courseData = JSON.parse(JSON.stringify(this.allData));

  }
  statusByDate(startDate: string, endDate: string) {

    if (new Date(startDate) <= this.currentDate && new Date(endDate) >= this.currentDate) return 'مستمرة';

    else if (new Date(endDate) < this.currentDate) return 'المكتملة';

    else if (new Date(startDate) > this.currentDate) return 'قيد الانتظار';

    return '';

  }
}
